import { buildEventUnreadMap } from './eventListStateUtils';

const normalizeRole = (role) => (String(role || '').toLowerCase() === 'admin' ? 'admin' : 'artist');

export const buildEventUnreadCountsUrl = ({ apiUrl, role, eventIds = [] } = {}) => {
  const safeApiUrl = String(apiUrl || '').replace(/\/$/, '');
  const safeRole = normalizeRole(role);
  const ids = Array.isArray(eventIds)
    ? eventIds.map((eventId) => String(eventId || '').trim()).filter(Boolean)
    : [];
  const base = `${safeApiUrl}/api/event-chat/unread-counts/${safeRole}`;
  if (!ids.length) return base;
  return `${base}?eventIds=${encodeURIComponent(ids.join(','))}`;
};

export const fetchEventUnreadMap = async ({
  apiUrl,
  role,
  eventIds = [],
  fetchJsonSafe,
  label = '',
} = {}) => {
  if (typeof fetchJsonSafe !== 'function') return {};
  const url = buildEventUnreadCountsUrl({ apiUrl, role, eventIds });
  const { unreadCounts = [] } = await fetchJsonSafe(url, {}, { label });
  return buildEventUnreadMap({ unreadCounts });
};
